import { mapState } from "vuex";

export default {
    methods: {
        generateRedirectUrl(response) {
            let redirectUrl = response.data.redirect
                ? response.data.redirect
                : '';

            return `${this.clientURL}/${redirectUrl}`;
        },

        showRegistrationForm() {
            this.$emit('changeView', {
                view: 'RegisterComponent'
            });
        },

        showForgotPasswordForm() {
            this.$emit('changeView', {
                view: 'ForgotPasswordComponent'
            })
        },

        showLoginForm() {
            this.$emit('changeView', {
                view: 'LoginComponent'
            });
        },
    },

    props: {
        successCallback: {
            type: Function,
            default: (redirectUrl) => {
                window.location.replace(redirectUrl);
            }
        },

        showSubmitButtons: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState([            
            'clientURL'
        ]),
    },
}
